import { withStyles } from '@material-ui/core/styles';

const styled = withStyles(theme => {
  return {
    root: {},
    grid: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  };
});

export default styled;
